import { Form, Input, Table, Tooltip } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form as FormR, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import AxiosHelper from "../../../helper/axios-helper";
import { getTokenUser } from "../../../helper/token";
import NavBar from "../../NavBar/navbar";
import SubNavBar from "../../SubNavBar/subnavbar";
import SharedModal from "../Shared/SharedModal";
import PencilIcon from "../../Home/pencil.png";

const VendorCost = () => {
  const [dropDownOptions, setDropDownOptions] = useState({
    Vendors: [],
  });
  const [vendorCosts, setVendorCosts] = useState([]);
  const [subNavValues, setSubNavValues] = useState([]);
  const [selectedVendorCosts, setSelectedVendorCosts] = useState();
  const [isModalOpen, setIsModalOpen] = useState({
    VendorCostAttachments: false,
    DeleteVendorCost: false,
  });
  const navigate = useNavigate();

  const tooltipColour = "#274D68";
  const EditableContext = React.createContext(null);

  const state = useLocation();
  const proposalId = state.state.split("-")[0];

  const getNewVendorCostId = () => {
    let largestId = 0;
    vendorCosts.forEach((vendorCost) => {
      if (vendorCost.VendorCostId > largestId) {
        largestId = vendorCost.VendorCostId;
      }
    });

    return largestId + 1;
  };

  const populateUI = () => {
    setVendorCosts([]);
    AxiosHelper.makeAxiosRequest(
      "Read",
      "Vendor",
      "GetVendorCosts",
      { propId: proposalId },
      null
    )
      .then((result) => {
        const data = result.data;
        if (data != null && data.length > 0) {
          const updatedVendorCosts = data.map((vendorCost, i) => {
            // Remove null attributes from vendorCost
            const filteredVendorCost = Object.fromEntries(
              Object.entries(vendorCost).map(([key, value]) => {
                const capitalizedKey =
                  key.charAt(0).toUpperCase() + key.slice(1);
                return [capitalizedKey, value];
              })
            );
            console.log(filteredVendorCost);
            filteredVendorCost.Key = vendorCost.vendorCostId;
            filteredVendorCost.VendorCostType = "Server";
            filteredVendorCost.VendorCostCreateDate =
              filteredVendorCost.VendorCostCreateDate.split("T")[0];
            filteredVendorCost.VendorCostInvoiceDate =
              filteredVendorCost.VendorCostInvoiceDate
                ? filteredVendorCost.VendorCostInvoiceDate.split("T")[0]
                : "-";
            return filteredVendorCost;
          });

          setVendorCosts(updatedVendorCosts);
          console.log(vendorCosts);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    AxiosHelper.makeAxiosRequest("Read", "Vendor", "GetVendors", null, null)
      .then((result) => {
        const data = result.data;
        const vendors = [{ id: -1, name: "" }];

        data.forEach((vendor) => {
          vendors.push({ id: vendor.VendorId, name: vendor.VendorName });
        });

        setDropDownOptions((prevState) => ({
          ...prevState,
          Vendors: vendors,
        }));
      })
      .catch((error) => {
        console.log(error);
      });

    setSubNavValues([]);

    AxiosHelper.makeAxiosRequest(
      "Read",
      "Summary",
      "GetRelatedCustomer",
      { proposalID: proposalId },
      null
    )
      .then((response) => {
        setSubNavValues((oldSubNavValues) => [
          ...oldSubNavValues,
          { heading: "Customer", text: response.data.value },
        ]);

        AxiosHelper.makeAxiosRequest("Read", "Proposal", "GetProposal", {
          proposalId: proposalId,
        }).then((response) => {
          setSubNavValues((oldSubNavValues) => [
            ...oldSubNavValues,
            { heading: "Proposal Name", text: response.data.PropName },
          ]);

          AxiosHelper.makeAxiosRequest(
            "Read",
            "Summary",
            "GetRelatedAccountManager",
            { proposalID: proposalId },
            null
          ).then((response) => {
            setSubNavValues((oldSubNavValues) => [
              ...oldSubNavValues,
              { heading: "Account Manager", text: response.data.value },
            ]);
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    populateUI();
  }, []);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleChange = (e, row, key) => {
    notifyChanges("The table contains unsaved changes.");

    row[key] = e.target.value;
    const newData = [...vendorCosts];

    const index = newData.findIndex((item) => row.Key === item.Key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });

    setVendorCosts(newData);
  };

  const getVendorName = (vendorId) => {
    const vendor = dropDownOptions.Vendors.find(
      (x) => x.id === Number(vendorId)
    );
    return vendor ? vendor.name : "";
  };

  const VendorCostColumns = [
    {
      title: "Vendor",
      dataIndex: "VendorId",
      render: (text, record, index) => {
        let isValid = true;
        if (
          record.VendorId === -1 ||
          record.VendorName === "-" ||
          record.VendorName === ""
        ) {
          isValid = false;
        }

        return (
          <div
            className="dropdown"
            style={{ width: "130px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select a vendor. Can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <Tooltip
              title={getVendorName(record.VendorId)}
              color={tooltipColour}
            >
              <FormR.Select
                size="sm"
                defaultValue={record.VendorId}
                onChange={(e) => {
                  handleChange(e, record, "VendorId");
                  handleChange(e, record, "VendorName");
                }}
                className={`${!isValid ? "invalid-cell" : ""}`}
              >
                {dropDownOptions.Vendors.map((x) => (
                  <option value={x.id}>{x.name}</option>
                ))}
              </FormR.Select>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "VendorCostDesc",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorCostDesc === "-" || record.VendorCostDesc === "") {
          isValid = false;
        }

        return (
          <div
            style={{ minWidth: "150px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Vendor Cost description can't be '-' or empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorCostDesc}
              onBlur={(e) => handleChange(e, record, "VendorCostDesc")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "VendorCostCreateDate",
      key: "VendorCostCreateDate",
      sorter: (a, b) =>
        new Date(a.VendorCostCreateDate) - new Date(b.VendorCostCreateDate),
      render: (text, record, index) => (
        <div style={{ width: "100px" }}>
          <FormR.Control
            className="editable-cell-input"
            size="sm"
            type="date"
            disabled={true}
            defaultValue={record.VendorCostCreateDate}
            onBlur={(e) => handleChange(e, record, "VendorCostCreateDate")}
          ></FormR.Control>
        </div>
      ),
    },
    {
      title: "Invoice Date",
      dataIndex: "VendorCostInvoiceDate",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorCostInvoiceDate === "-") {
          isValid = false;
        }

        return (
          <div
            style={{ display: "flex", position: "relative", maxWidth: "100px" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select a date to, can't be empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="date"
              defaultValue={record.VendorCostInvoiceDate}
              onBlur={(e) => handleChange(e, record, "VendorCostInvoiceDate")}
              style={{ maxWidth: "100px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Total Exc",
      dataIndex: "VendorCostTotalExc",
      render: (text, record, index) => {
        let isValid = true;

        if (parseFloat(record.VendorCostTotalExc) <= 0) {
          isValid = false;
        }

        return (
          <div
            style={{ width: "150px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Cost value can't be neagtive or 0."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorCostTotalExc.toString().replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )}
              onBlur={(e) => handleChange(e, record, "VendorCostTotalExc")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Document",
      dataIndex: "VendorCostFileLink",
      render: (text, record, index) => (
        <div style={{ display: "flex" }}>
          {record.VendorCostFileLink === "" ||
          record.VendorCostFileLink === null ||
          record.VendorCostFileLink === undefined ||
          record.VendorCostFileLink === "-" ? (
            <p className="non-editable-cell">No File</p>
          ) : (
            <a
              className="non-editable-cell"
              href={record.VendorCostFileLink}
              rel="noreferrer"
              target="_blank"
            >
              View
            </a>
          )}
          <Tooltip title={"Edit Link"} color={tooltipColour}>
            <img
              className="pencil-icon"
              src={PencilIcon}
              alt="Not Found!"
              onClick={() => handleVendorCostAttachments(record)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Actions",
      render: (text, record, index) => (
        <Tooltip title="Delete Vendor Cost" color={tooltipColour}>
          <img
            className="delete-icon"
            src={require("../../CustomerListView/delete.png")}
            alt="Not Found!"
            onClick={() => {
              handleOpenModal("DeleteVendorCost");
              setSelectedVendorCosts(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];

  const handleVendorCostAttachments = (record, index) => {
    setSelectedVendorCosts(record);
    handleOpenModal("VendorCostAttachments");
  };

  const handleDeleteVendorCost = (record) => {
    const updatedVendorCosts = vendorCosts.filter(
      (vendorCost) => vendorCost.Key !== record.Key
    );
    if (record.VendorCostType === "Server") {
      AxiosHelper.makeAxiosRequest(
        "Delete",
        "Vendor",
        "DeleteVendorCost",
        { currUserId: getTokenUser(), vendorCostId: record.VendorCostId },
        null
      )
        .then(() => {
          notifySuccessful("Vendor cost deleted successfully");
        })
        .catch((error) => {
          notifyFailed("Failed to delete vendor cost");
          console.log(error);
        });
    } else {
      notifySuccessful("Vendor cost deleted successfully");
    }
    setVendorCosts(updatedVendorCosts);
    handleCloseModal("DeleteVendorCost");
  };

  const notifySuccessful = (message) => {
    toast.dismiss();
    toast.success(message, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyFailed = (message) => {
    toast.dismiss();
    toast.error(message, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyChanges = (message) => {
    toast.warning(message, {
      toastId: "ToastDataTableWarning",
      position: "top-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      progress: undefined,
      closeButton: true,
    });
  };

  const isValid = () => {
    let valid = true;
    vendorCosts.forEach((vendorCost) => {
      if (
        vendorCost.VendorId === -1 ||
        vendorCost.VendorCostDesc === "" ||
        vendorCost.VendorCostDesc === "-" ||
        vendorCost.VendorCostInvoiceDate === "-" ||
        vendorCost.VendorCostTotalExc <= 0
      ) {
        valid = false;
      }
    });
    return valid;
  };

  const handleSave = () => {
    if (isValid()) {
      vendorCosts.forEach((vendorCost, index) => {
        const vendorCostSave = {
          VendorCostId:
            vendorCost.VendorCostType === "Client"
              ? 0
              : Number(vendorCost.VendorCostId),
          VendorId: Number(vendorCost.VendorId),
          VendorCostDesc: vendorCost.VendorCostDesc,
          PropId: Number(proposalId),
          VendorCostCreateDate: vendorCost.VendorCostCreateDate,
          VendorCostTotalExc: parseFloat(
            vendorCost.VendorCostTotalExc.toString().replace(/,/g, "")
          ),
          VendorCostTotalInc:
            parseFloat(
              vendorCost.VendorCostTotalExc.toString().replace(/,/g, "")
            ) * 1.15,
          VendorCostFileLink: vendorCost.VendorCostFileLink,
          VendorCostInvoiceDate: vendorCost.VendorCostInvoiceDate,
          VendorCostDeleted: false,
        };

        if (vendorCost.VendorCostType === "Client") {
          AxiosHelper.makeAxiosRequest(
            "Create",
            "Vendor",
            "AddVendorCost",
            { currentUserId: getTokenUser() },
            vendorCostSave
          )
            .then((response) => {
              notifySuccessful("Vendor cost added successfully");
              const newVendorCostId = response.data;
              const updatedVendorCosts = [...vendorCosts];
              updatedVendorCosts[index].VendorCostId = newVendorCostId;
              updatedVendorCosts[index].key = newVendorCostId;
              updatedVendorCosts[index].VendorCostType = "Server";
              setVendorCosts(updatedVendorCosts);
            })
            .catch((error) => {
              notifyFailed("Failed to add vendor cost");
              console.log(error);
            });
        } else {
          AxiosHelper.makeAxiosRequest(
            "Create",
            "Vendor",
            "UpdateVendorCosts",
            { currentUserId: getTokenUser() },
            vendorCostSave
          )
            .then((response) => {
              notifySuccessful("Vendor cost updated successfully");
            })
            .catch((error) => {
              notifyFailed("Failed to update vendor cost");
              console.log(error);
            });
        }
      });
    } else {
      notifyFailed("Please fill in all the fields correctly");
    }
  };

  const handleCloseModal = (modal) => {
    setIsModalOpen((prevState) => ({
      ...prevState,
      [modal]: false,
    }));
  };

  const handleOpenModal = (modal) => {
    setIsModalOpen((prevState) => ({
      ...prevState,
      [modal]: true,
    }));
  };

  const handleAddVendorCost = () => {
    const newVendorCost = {
      Key: getNewVendorCostId(),
      VendorCostId: getNewVendorCostId(),
      VendorCostType: "Client",
      VendorId: -1,
      VendorName: "",
      VendorCostDesc: "",
      VendorCostCreateDate: new Date().toISOString().split("T")[0],
      VendorCostTotalExc: 0,
      VendorCostAttachments: [],
    };

    setVendorCosts((prevState) => [...prevState, newVendorCost]);
  };

  const handleBack = () => {
    navigate("/home");
  };

  const handleUpdateDocumentLink = (documentLink) => {
    setSelectedVendorCosts((prevState) => ({
      ...prevState,
      VendorCostFileLink: documentLink,
    }));
  };

  const handleSaveDocumentLink = () => {
    const updatedVendorCosts = vendorCosts.map((vendorCost) => {
      if (vendorCost.Key === selectedVendorCosts.Key) {
        return selectedVendorCosts;
      }
      return vendorCost;
    });

    setVendorCosts(updatedVendorCosts);
    handleCloseModal("VendorCostAttachments");
  };

  return (
    <>
      <ToastContainer />
      <NavBar />
      <SubNavBar values={subNavValues} />

      <SharedModal
        isOpen={isModalOpen.DeleteVendorCost}
        title={"Delete Vendor Cost"}
        onDelete={() => handleDeleteVendorCost(selectedVendorCosts)}
        onClose={() => handleCloseModal("DeleteVendorCost")}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <p className="p-main">
              Are you sure you want to delete the following Vendor Cost?
              <br />
              This change can not be reversed.
            </p>
          </div>
          <div>
            <p className="p-main">{selectedVendorCosts?.VendorCostDesc}</p>
          </div>
        </div>
      </SharedModal>

      <SharedModal
        isOpen={isModalOpen.VendorCostAttachments}
        title={"Edit Vendor Cost Document Link"}
        onClose={() => handleCloseModal("VendorCostAttachments")}
        onOkay={() => handleSaveDocumentLink()}
      >
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <h6 style={{ marginTop: "auto" }}>Document Link:</h6>
          <FormR.Control
            type="text"
            defaultValue={
              selectedVendorCosts ? selectedVendorCosts.VendorCostFileLink : ""
            }
            style={{ maxWidth: "fit-content" }}
            onBlur={(e) => {
              if (!(e.target.value === "-")) {
                handleUpdateDocumentLink(e.target.value);
              }
            }}
          />
        </div>
      </SharedModal>

      <Container fluid id="proposal-update-container">
        <div className="proposal-collapse-toggle-container">
          <Row className="proposal-collapse-toggle-wrapper gx-0">
            <Col style={{ display: "flex" }}>
              <p className="proposal-collapse-toggle">View Vendor Costs</p>
            </Col>
          </Row>

          <Table
            components={components}
            columns={VendorCostColumns}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false,
              defaultPageSize: 100,
              hideOnSinglePage: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
            }}
            dataSource={vendorCosts}
            footer={() => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button onClick={handleAddVendorCost}>Add</Button>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Button
                    onClick={() => handleBack()}
                    style={{ alignSelf: "right" }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="danger"
                    onClick={populateUI}
                    style={{ alignSelf: "right" }}
                  >
                    Clear Changes
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => {
                      handleSave();
                    }}
                    style={{ alignSelf: "right" }}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            )}
          ></Table>
        </div>
      </Container>
    </>
  );
};

export default VendorCost;
